import { ComponentTypes } from "../../config/config";
import { IUserSettings } from "../../interfaces/IUserProfile";
import { UserLicenseTypeEnum } from "../enums/userLicenseTypeEnum";

export class AccessLicenseHelper {
    static canAccessItem = (licenseType: UserLicenseTypeEnum, locationType: string) => {
        return (
            // licenseType === UserLicenseTypeEnum.Paid ||
            // (locationType === ComponentTypes.OneDrive && licenseType === UserLicenseTypeEnum.Free)
            licenseType !== UserLicenseTypeEnum.Expired || locationType === ComponentTypes.OneDrive
        );
    };

    static isLocationEnabled = (locationType: string, settings: IUserSettings) => {
        if (locationType === ComponentTypes.OneDrive || locationType === ComponentTypes.OneDriveSubFolder) {
            return { canAccess: settings.enableOneDrive, type: ComponentTypes.OneDrive };
        }

        if (locationType === ComponentTypes.SharePoint 
            || locationType === ComponentTypes.SharePointList
            || locationType === ComponentTypes.SharePointDocuments
            || locationType === ComponentTypes.SharePointFolders) {
            return { canAccess: settings.enableSharePoint, type: ComponentTypes.SharePoint };
        }

        if (locationType === ComponentTypes.Teams
            || locationType === ComponentTypes.TeamFolders
            || locationType === ComponentTypes.TeamDocuments) {
            return { canAccess: settings.enableTeams, type: ComponentTypes.Teams };
        }
        return { canAccess: false, type: "other" };
    }
}